// PlanComponents/OverviewCard.js
import React from 'react';
import { Typography } from '@mui/material';

import CardItem from './CardItem';
import AdviceContentBox from '../../../components/AdviceContentBox';


export default function OverviewCard({ overview, adv }) {
  return (
    <CardItem
      title="概要"
      adviceContent={<AdviceContentBox adviceObj={adv.overview} />}
    >
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
        {overview || '未設定'}
      </Typography>
    </CardItem>
  );
}